import { render } from "./NoticiasApp.vue?vue&type=template&id=03592335&scoped=true"
import script from "./NoticiasApp.vue?vue&type=script&lang=js"
export * from "./NoticiasApp.vue?vue&type=script&lang=js"

import "./NoticiasApp.vue?vue&type=style&index=0&id=03592335&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03592335"]])

export default __exports__